export const MODULE_PREFIX = "m";
export const SLOT_PREFIX = "s";

export const DOCKING_ACTIONS = {
    "Undock" : "undock",
    "Dock" : "dock"
}

export const INVENTORY_ERROR_MESSAGES = {
    "OFFLINE" : "Offline",
    "NOT_DOCKED" : "Undocked",
    "LOCKED" : "Locked",
    "EXPIRED" : "Expired",
    "SOLD_OUT" : "Sold out",
    "DEFAULT" : "Something is wrong"
}